import { useEffect, useMemo, useState } from 'react';

const hasCoordinates = (item) => {
  const latitude = item?.location?.latitude ?? item?.latitude;
  const longitude = item?.location?.longitude ?? item?.longitude;

  return Number.isFinite(latitude) && Number.isFinite(longitude);
};

const useEntityMapView = (storageKey, items) => {
  const [viewMode, setViewMode] = useState('list');

  useEffect(() => {
    if (!storageKey) {
      return;
    }

    const savedMode = localStorage.getItem(storageKey);

    if (savedMode === 'list' || savedMode === 'map') {
      setViewMode(savedMode);
    }
  }, [storageKey]);

  useEffect(() => {
    if (!storageKey) {
      return;
    }

    localStorage.setItem(storageKey, viewMode);
  }, [storageKey, viewMode]);

  const hasMappableEntities = useMemo(() => {
    if (!Array.isArray(items)) {
      return false;
    }

    return items.some(hasCoordinates);
  }, [items]);

  useEffect(() => {
    if (!hasMappableEntities && viewMode === 'map') {
      setViewMode('list');
    }
  }, [hasMappableEntities, viewMode]);

  return {
    viewMode,
    setViewMode,
    hasMappableEntities
  };
};

export default useEntityMapView;
